import pickupParkingFacilityFeatureCollectionData from '@/data/pickup-parking-facilities.json';
import { FeatureType } from '@/types/FeatureType';
import type { PickupParkingFacilityFeatureCollection } from '@/types/PickupParkingFacilityFeature';

export const pickupParkingFacilityFeatureCollection = {
  ...pickupParkingFacilityFeatureCollectionData,

  features: pickupParkingFacilityFeatureCollectionData.features.map((feature) => ({
    ...feature,

    properties: {
      ...feature.properties,
      id: String(feature.properties.objectid),
      featureType: FeatureType.PICKUP_PARKING_FACILITY,
      name: feature.properties.featurename,
    },
  })),
} as PickupParkingFacilityFeatureCollection;
